module.exports = __webpack_public_path__ + "img/publishicon.ac735c3.png";